import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import CommonHeader from '@/components/CommonHeader.vue';
import AjaxButton from '@/components/AjaxButton.vue';
import BeeCheckbox from '@/components/BeeCheckbox.vue';
import Google from '@/components/ButtonGoogle.vue';
import Facebook from '@/components/ButtonFacebook.vue';
import LineDecoration from '@/components/LineDecoration.vue';
import auth from '@/config/auth';
import SpinnerHolder from '@/components/SpinnerHolder.vue';
import { getUser } from "@/services/UserService";
import { redirect } from '@/utils/RedirectUtils';
let Login = class Login extends Vue {
    constructor() {
        super(...arguments);
        this.loading = false;
        this.loadingSpinner = false;
        this.selected = false;
        this.email = '';
        this.password = '';
        this.confirmPassword = '';
        this.showPassword = false;
        this.showConfirmPassword = false;
        this.displayError = false;
        this.error = '';
        this.menu = this.$store.state.menu;
    }
    async sigUpWithEmail() {
        this.loading = true;
        this.displayError = false;
        this.error = '';
        if (this.password.length < 6) {
            this.error = this.$t('weakPassword').toString();
            this.displayError = true;
            this.loading = false;
            return;
        }
        if (this.password !== this.confirmPassword) {
            this.error = this.$t('wrongPasswordConfirm').toString();
            this.displayError = true;
            this.loading = false;
            return;
        }
        if (!this.selected) {
            this.error = this.$t('wrongTerm').toString();
            this.displayError = true;
            this.loading = false;
            return;
        }
        try {
            await auth.createUserWithEmailAndPassword(this.email.trim(), this.password.trim());
            this.$analytics.logEvent('sign_up', {
                method: 'Email'
            });
            redirect();
        }
        catch (e) {
            switch (e.code) {
                case ('auth/invalid-email'):
                    this.error = this.$t('invalidEmail').toString();
                    this.loading = false;
                    break;
                case ('auth/email-already-in-use'):
                    this.error = this.$t('emailInUse').toString();
                    this.loginWithEmail();
                    this.loading = false;
                    break;
                case ('auth/operation-not-allowed'):
                    this.error = this.$t('defaultErrorSigIn').toString();
                    this.loading = false;
                    break;
                case ('auth/weak-password'):
                    this.error = this.$t('weakPassword').toString();
                    this.loading = false;
                    break;
                default:
                    this.error = this.$t('defaultErrorSigIn').toString();
                    this.loading = false;
                    break;
            }
            this.$analytics.logEvent('sign_up_error', {
                method: 'Email',
                error: e.code
            });
            this.displayError = true;
        }
        this.loading = false;
    }
    async loginWithEmail() {
        this.loadingSpinner = true;
        this.displayError = false;
        this.error = '';
        try {
            const response = await auth.signInWithEmailAndPassword(this.email.trim(), this.password.trim());
            if (response.user) {
                this.$analytics.logEvent('login', {
                    method: 'Email'
                });
                const user = await getUser(response.user);
                await this.$store.dispatch('login', user);
                redirect();
                this.loadingSpinner = false;
            }
        }
        catch (e) {
            switch (e.code) {
                case ('auth/invalid-email'):
                    this.error = this.$t('invalidEmail').toString();
                    break;
                case ('auth/user-disabled'):
                    this.error = this.$t('userDisabled').toString();
                    break;
                case ('auth/user-not-found'):
                    this.error = this.$t('userNotFound').toString();
                    break;
                case ('auth/wrong-password'):
                    this.error = this.$t('wrongPassword').toString();
                    break;
                default:
                    this.error = this.$t('defaultErrorSigIn').toString();
                    break;
            }
            this.$analytics.logEvent('login_error', {
                method: 'Email',
                error: e.code
            });
            this.loadingSpinner = false;
            this.displayError = true;
        }
    }
    resetForm() {
        this.error = '';
        this.displayError = false;
    }
    newPassword() {
        this.$router.push("/wrongPassword");
    }
};
Login = __decorate([
    Component({
        components: {
            CommonHeader,
            AjaxButton,
            BeeCheckbox,
            Google,
            Facebook,
            LineDecoration,
            SpinnerHolder
        }
    })
], Login);
export default Login;
